/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../AddEmployee/AddEmployee.css";
import Select from "react-select";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Loader from "../../../Components/loader/loader";

const AddEmployee = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const comingData = location.state;
  const isUpdate = !!comingData;

  const [addEmloyee, setAddEmloyee] = useState({
    Name: "",
    LastName: "",
    Address: "",
    Email: "",
    Phone: "",
    EmergencyContact: "",
    Gender: "",
    MaritalStatus: "",
    DateOfBirth: "",
    DateOfJoining: "",
    DateOfLeaving: "",
    Department: "",
    Designation: "",
    TeamLead: "",
    UserRole: "",
    UploardImage: "",
    AdhaarCardFront: "",
    AdhaarCardBack: "",
    Password: "",
    ImageExtension: "",
    ImageName: "",
    AdhaarFrontExtension: "",
    AdhaarFrontName: "",
    AdhaarBackExtension: "",
    AdhaarBackName: "",
    Education: "",
    UrlLink: "",
  });

  const [departmentData, setDepartmentData] = useState([]);
  const [saveDesignationOfDepartment, setSaveDesignationOfDepartment] = useState("");
  const [teamLeadData, setTeamLeadData] = useState([]);
  const [isFinalTeamLeadData, setIsFinalTeamLeadData] = useState("");
  const [DesignationData, setDesignationData] = useState([]);
  const [filterTeamValue, setFilterTeamValue] = useState();
  const [userRoleData, setUserRoleData] = useState([]);
  const currentDate = new Date().toISOString().split("T")[0];
  const [showSidebar, setShowSidebar] = useState(true);
  const fileInputRef = useRef(null);
  const adhaarFileInputRef = useRef(null);
  const adhaarFrontFileInputRef = useRef(null);
  const adhaarBackFileInputRef = useRef(null);
  const [departmentId, setDepartmentId] = useState("");
  const [designationId, setDesignationId] = useState("");
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [adhaarImageFile, setAdhaarImageFile] = useState(null);
  const [adhaarImageFiles, setAdhaarImageFiles] = useState([]);

  const handleDepartmentChange = (selectedOption) => {
    setDepartmentId(selectedOption?.value);
    setAddEmloyee({ ...addEmloyee, Department: selectedOption, Designation: "", TeamLead: "" });
    setSaveDesignationOfDepartment(selectedOption);
  };

  const handleDesignationData = (selectedOption) => {
    setAddEmloyee({ ...addEmloyee, Designation: selectedOption, TeamLead: "" });
    setSaveDesignationOfDepartment(selectedOption);
    setDesignationId(selectedOption?.Id);
  };

  const [finalUserRole, setFinalUserRole] = useState();
  const [userRoleError, setUserRoleError] = useState();

  const handleTeamLeadData = (e) => {
    setIsFinalTeamLeadData(e);
    setAddEmloyee({ ...addEmloyee, TeamLead: e });
  };

  const handleUserRole = (e) => {
    setFinalUserRole(e);
    setAddEmloyee({ ...addEmloyee, UserRole: e, Department: "" });
    setDesignationData([]);
  };

  useEffect(() => {
    if (teamLeadData) {
      const filter = teamLeadData?.filter((i) => i?.UserId === comingData?.TeamLead);
      setFilterTeamValue(filter);
      setAddEmloyee({ ...addEmloyee, TeamLead: filter?.[0] });
    }
  }, [teamLeadData]);

  const DateOfBirth = (e) => {
    const selectedDate = e.target.value;
    const today = new Date();
    const birthDate = new Date(selectedDate);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      age < 18 ||
      (age === 18 && (monthDiff > 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())))
    ) {
      setAddEmloyee({ ...addEmloyee, DateOfBirth: "" });
    } else {
      setAddEmloyee({ ...addEmloyee, DateOfBirth: selectedDate });
    }
  };

  const handleFileChange = (event, fileType = "image") => {
    if (fileType === "adhaar") {
      const files = event.target.files;
      if (files && files.length > 0) {
        const fileArray = Array.from(files);
        setAdhaarImageFiles(fileArray);
      }
    } else {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Image = reader.result;
          const fileExtension = file.name.split(".").pop().toLowerCase();
          setAddEmloyee({
            ...addEmloyee,
            UploardImage: file,
            ImageExtension: fileExtension,
            ImageName: file,
            PreviewImage: base64Image,
          });
          setProfileImageFile(file);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => setShowSidebar(false), 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const Gender = [
    { value: "Male", label: "Male", id: 0 },
    { value: "Female", label: "Female", id: 1 },
    { value: "Other", label: "Other", id: 2 },
  ];

  const MaritalStatusOptions = [
    { value: "Single", label: "Single", id: 0 },
    { value: "Married", label: "Married", id: 1 },
    { value: "Divorced", label: "Divorced", id: 2 },
    { value: "Widowed", label: "Widowed", id: 3 },
  ];

  const ComingEditDob = moment(comingData?.DateOfBirth).format("YYYY-MM-DD");
  const ComingEditDateOfJoining = moment(comingData?.DateofJoining).format("YYYY-MM-DD");
  const ComingEditDateOfLeaving = comingData?.DateOfLeaving
    ? moment(comingData?.DateOfLeaving).format("YYYY-MM-DD")
    : " ";
  const ComingGender = Gender?.filter((i) => i?.id === comingData?.Gender);
  const SUBDesignation = DesignationData?.find(
    (e) => e.DesignationName === comingData?.Designations?.DesignationName
  );
  const ComingDepartment = departmentData?.filter((e) => e?.value === comingData?.Department);
  const ComingRole = userRoleData?.filter((e) => e?.Id === comingData?.Position);

  useEffect(() => {
    if (comingData) {
      const TeamLeadArray = [...teamLeadData];
      const filteredTeamLead = TeamLeadArray?.filter((e) => e.UserId === comingData?.TeamLead);
      setAddEmloyee({
        Name: comingData?.FirstName,
        LastName: comingData?.LastName,
        Email: comingData?.Email,
        Address: comingData?.Address,
        Phone: comingData?.Mobile,
        EmergencyContact: comingData?.Emergencycontactno,
        Gender: ComingGender,
        DateOfBirth: ComingEditDob,
        DateOfJoining: ComingEditDateOfJoining,
        DateOfLeaving: ComingEditDateOfLeaving || "",
        Department: comingData?.Departments,
        Position: comingData?.Position,
        Designation: comingData?.Designations,
        UserRole: comingData?.Positions,
        TeamLead: filteredTeamLead || null,
        MaritalStatus: MaritalStatusOptions?.find((e) => e?.id === comingData?.MaritalStatus) || null,
        Education: comingData?.Education || "",
        UrlLink: comingData?.UrlLink || "",
        UploardImage: comingData?.UrlLink || "",
        AdhaarCardFront: comingData?.AadharCardFront || "",
        AdhaarCardBack: comingData?.AadharCardBack || "",
      });
      const userRole = ComingRole?.[0] || "";
      setFinalUserRole(userRole);
      setDepartmentId(comingData?.Designations?.Id);
    }
  }, [comingData]);

  const [errorName, setErrorName] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorEmergencyContact, setErrorEmergencyContact] = useState(false);
  const [errorDateOfBirth, setErrorDateOfBirth] = useState(false);
  const [errorDateOfJoining, setErrorDateOfJoining] = useState(false);
  const [errorDateofLeaving, setErrorDateOfLeaving] = useState(false);
  const [errorGender, setErrorGender] = useState(false);
  const [errorMaritalStatus, setErrorMaritalStatus] = useState(false);
  const [uploadAdhaarFrontError, setUploadAdhaarFrontError] = useState(false);
  const [uploadAdhaarBackError, setUploadAdhaarBackError] = useState(false);
  const [uploadAdhaarError, setUploadAdhaarError] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);
  const [designationDepartmentError, setDesignationDepartmentError] = useState(false);
  const [teamLeadDepartMentError, setTeamLeadDepartMentError] = useState(false);
  const [uploadImageError, setUploadImageError] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  function isValidEmail(Email) {
    return emailRegex.test(Email);
  }

  // ADD validation — First Name, Role, Email, Password, Aadhaar mandatory
  const validateAdd = () => {
    if (!addEmloyee?.Name) {
      setErrorName("usernamedata");
      toast.error("First Name is required.");
      return false;
    }
    if (!addEmloyee?.Email) {
      setErrorEmail("userEmail");
      toast.error("Email is required.");
      return false;
    }
    if (!isValidEmail(addEmloyee?.Email)) {
      toast.error("Please enter a valid email.");
      return false;
    }
    if (!addEmloyee?.Password) {
      setErrorPassword("password");
      toast.error("Password is required.");
      return false;
    }
    if (!addEmloyee.UserRole) {
      setUserRoleError("userRole");
      toast.error("User Role is required.");
      return false;
    }
    if (!adhaarImageFiles || adhaarImageFiles.length === 0) {
      toast.error("Aadhaar files are required.");
      return false;
    }
    return true;
  };

  // UPDATE validation — Name, Email, DOB, DOJ mandatory
  const validateUpdate = () => {
    if (!addEmloyee?.Name) {
      setErrorName("usernamedata");
      toast.error("First Name is required.");
      return false;
    }
    if (!addEmloyee?.Email) {
      setErrorEmail("userEmail");
      toast.error("Email is required.");
      return false;
    }
    if (!isValidEmail(addEmloyee?.Email)) {
      toast.error("Please enter a valid email.");
      return false;
    }
    if (!addEmloyee?.DateOfBirth) {
      setErrorDateOfBirth("userDateOfBirth");
      toast.error("Date of Birth is required.");
      return false;
    }
    if (!addEmloyee?.DateOfJoining) {
      setErrorDateOfJoining("userDateOfJoining");
      toast.error("Date of Joining is required.");
      return false;
    }
    return true;
  };

  const handleAddEmployee = (e) => {
    e?.preventDefault();

    if (isUpdate) {
      if (!validateUpdate()) return;
    } else {
      if (!validateAdd()) return;
    }

    setLoading(true);
    const LoginToken = GetToken();
    const formData = new FormData();

    if (comingData) formData.append("Id", comingData?.Id);

    if (addEmloyee?.Name) formData.append("FirstName", addEmloyee?.Name);
    if (addEmloyee?.LastName) formData.append("LastName", addEmloyee?.LastName);
    if (addEmloyee?.Gender?.id !== undefined) formData.append("Gender", addEmloyee?.Gender?.id);
    if (addEmloyee?.Phone) formData.append("Mobile", addEmloyee?.Phone);
    if (addEmloyee?.Designation?.Id) formData.append("Designation", addEmloyee.Designation.Id);

    const departmentValue = addEmloyee?.Department?.value || addEmloyee?.Department?.Id;
    if (departmentValue) formData.append("Department", departmentValue);

    if (addEmloyee?.Address) formData.append("Address", addEmloyee?.Address);
    if (addEmloyee?.DateOfBirth) formData.append("DateOfBirth", addEmloyee?.DateOfBirth);
    if (addEmloyee?.Education) formData.append("Education", addEmloyee?.Education);
    if (addEmloyee?.UserRole?.Id) formData.append("Position", addEmloyee?.UserRole?.Id);

    const teamLeadValue = filterTeamValue?.[0]?.UserId || addEmloyee?.TeamLead?.UserId;
    if (teamLeadValue) formData.append("TeamLead", teamLeadValue);

    if (addEmloyee?.DateOfJoining) formData.append("DateOfJoining", addEmloyee?.DateOfJoining);
    if (addEmloyee?.DateOfLeaving) formData.append("DateofLeaving", addEmloyee?.DateOfLeaving);
    if (addEmloyee?.EmergencyContact) formData.append("Emergencycontactno", addEmloyee?.EmergencyContact);

    if (addEmloyee?.MaritalStatus) {
      const maritalStatusValue = addEmloyee?.MaritalStatus?.id;
      if (maritalStatusValue !== undefined && maritalStatusValue !== null) {
        formData.append("MaritalStatus", maritalStatusValue);
      }
    }

    if (isUpdate) {
      if (addEmloyee?.AadharCardFront) formData.append("AadharCardFront", addEmloyee?.AadharCardFront);
      if (addEmloyee?.AadharCardBack) formData.append("AadharCardBack", addEmloyee?.AadharCardBack);
    }

    // Aadhaar files — only for ADD
    if (!isUpdate && adhaarImageFiles && adhaarImageFiles.length > 0) {
      adhaarImageFiles.forEach((file) => formData.append("AadharFiles", file));
    }

    if (addEmloyee?.UploardImage) {
      if (addEmloyee?.UploardImage instanceof File) {
        formData.append("Photo", addEmloyee?.UploardImage);
        if (addEmloyee?.ImageExtension) formData.append("PhotoExtenssion", addEmloyee?.ImageExtension);
      } else if (typeof addEmloyee?.UploardImage === "string" && addEmloyee?.UploardImage.startsWith("data:")) {
        formData.append("Photo", addEmloyee?.UploardImage);
        if (addEmloyee?.ImageExtension) formData.append("PhotoExtenssion", addEmloyee?.ImageExtension);
      } else if (typeof addEmloyee?.UploardImage === "string" && !addEmloyee?.UploardImage.startsWith("http")) {
        formData.append("Photo", addEmloyee?.UploardImage);
        if (addEmloyee?.ImageExtension) formData.append("PhotoExtenssion", addEmloyee?.ImageExtension);
      } else if (typeof addEmloyee?.UploardImage === "string" && addEmloyee?.UploardImage.startsWith("http")) {
        formData.append("UrlLink", addEmloyee?.UploardImage);
      }
    } else if (isUpdate && comingData?.UrlLink) {
      formData.append("UrlLink", comingData?.UrlLink);
    }

    // Email & Password — only for ADD
    if (!isUpdate) {
      if (addEmloyee?.Email) formData.append("Email", addEmloyee?.Email);
      if (addEmloyee?.Password) formData.append("Password", addEmloyee?.Password);
    }

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/SaveEmployee`,
      data: formData,
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setAddEmloyee({
            Name: "", LastName: "", Address: "", Email: "", Phone: "",
            EmergencyContact: "", Gender: "", DateOfBirth: "", DateOfJoining: "",
            DateOfLeaving: "", Department: "", Designation: "", TeamLead: "",
            UserRole: "", UploardImage: "", Password: "", ImageExtension: "",
            MaritalStatus: "", AdhaarImage: "", AdhaarExtension: "", AdhaarName: "",
          });
          setProfileImageFile(null);
          setAdhaarImageFiles([]);
          setErrorName(""); setErrorLastName(""); setErrorEmail("");
          setErrorAddress(""); setErrorPhone(""); setErrorEmergencyContact("");
          setErrorPassword(""); setErrorDateOfBirth(""); setErrorDateOfJoining("");
          setErrorDateOfLeaving(""); setErrorGender(""); setUserRoleError("");
          setUploadImageError(""); setDepartmentError("");
          setDesignationDepartmentError(""); setTeamLeadDepartMentError("");
          if (fileInputRef.current) fileInputRef.current.value = null;
          if (adhaarFileInputRef.current) adhaarFileInputRef.current.value = null;
          setAdhaarImageFiles([]);
          if (comingData) navigate("/Adm/Employees/AllEmployees");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({ label: item?.Name, value: item?.Id }));
        setDepartmentData(finalData);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { getDepartment(); }, []);

  const handleDesignations = (e) => {
    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    data.DepartmentId = addEmloyee?.Department?.value || addEmloyee?.Department?.Id;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetDesignations`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setDesignationData(data);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (departmentId) {
      setSaveDesignationOfDepartment("");
      setDesignationId("");
      setTeamLeadData("");
      setIsFinalTeamLeadData("");
      handleDesignations();
    }
  }, [departmentId]);

  const GetTeamLeads = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    if (saveDesignationOfDepartment?.Id) {
      data.Department = saveDesignationOfDepartment?.Department?.Id;
      data.Designation = saveDesignationOfDepartment?.Id;
    } else {
      data.Department = addEmloyee?.Department?.Id;
      data.Designation = addEmloyee?.Designation?.Id;
    }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetTeamleads`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setTeamLeadData(data);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    if (saveDesignationOfDepartment) {
      setAddEmloyee({ ...addEmloyee, TeamLead: "" });
      setIsFinalTeamLeadData("");
      GetTeamLeads(saveDesignationOfDepartment);
    }
  }, [saveDesignationOfDepartment]);

  useEffect(() => {
    if (addEmloyee.Designation || addEmloyee.Department) {
      GetTeamLeads();
    }
  }, [addEmloyee.Designation, addEmloyee.Department]);

  const GetUserRole = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetPositions`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setUserRoleData(data);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { GetUserRole(); }, []);

  useEffect(() => {
    if (addEmloyee?.UserRole?.RoleName === "HR") {
      const defaultDepartment = departmentData.find((d) => d.label === "Management");
      handleDepartmentChange(defaultDepartment);
    }
  }, [addEmloyee?.UserRole]);

  const handleEmptyInputData = () => {
    setAddEmloyee({
      Name: "", LastName: "", Address: "", Email: "", Phone: "",
      EmergencyContact: "", Gender: "", MaritalStatus: "", DateOfBirth: "",
      DateOfJoining: "", DateOfLeaving: "", Department: "", Designation: "",
      TeamLead: "", UserRole: "", UploardImage: "", AdhaarImage: "",
      Password: "", ImageExtension: "", ImageName: "", AdhaarExtension: "", AdhaarName: "",
    });
    setErrorName(""); setErrorLastName(""); setErrorEmail("");
    setErrorAddress(""); setErrorPhone(""); setErrorEmergencyContact("");
    setErrorPassword(""); setErrorDateOfBirth(""); setErrorDateOfJoining("");
    setErrorDateOfLeaving(""); setErrorGender(""); setErrorMaritalStatus("");
    setUserRoleError(""); setUploadImageError(""); setUploadAdhaarError("");
    setDepartmentError(""); setDesignationDepartmentError(""); setTeamLeadDepartMentError("");
    if (fileInputRef.current) fileInputRef.current.value = null;
    if (adhaarFileInputRef.current) adhaarFileInputRef.current.value = null;
    setAdhaarImageFiles([]);
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <section className={showSidebar ? "addEmloyees-section" : "addEmloyees-section-new"}>
          {/* Page Header */}
          <div className="addEmloyees-all-icons">
            <p className="DASHBOARD-MAIN-HEADING">
              {isUpdate ? "Update Employee" : "Add Employee"}
            </p>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p>Employees</p>
              <MdKeyboardArrowRight />
              <p>{isUpdate ? "Update Employee" : "Add Employee"}</p>
            </div>
          </div>

          <div className="Addemployee-main-container">
            <div className="Addemployee-outter-container">
              {/* Form Title */}
              <div className="AddEmployee-heading">
                <p>{isUpdate ? "Update Employee" : "Add Employee"}</p>
              </div>

              {/* Important Note */}
              <div className="addemployee-note">
                ℹ️ <strong>Note:</strong> Please ensure the employee's name matches exactly as it appears on the attendance sheet.
              </div>

              <div className="Addemployee-inner-container">
                <div className="Addemployee-inner-box row">

                  {/* ── SECTION: Personal Information ── */}
                  <div className="addemployee-section-title col-12">Personal Information</div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="First Name*"
                      value={addEmloyee?.Name}
                      onChange={(e) => setAddEmloyee({ ...addEmloyee, Name: e?.target?.value })}
                      onBlur={(e) => setErrorName(!e?.target?.value ? "usernamedata" : "false")}
                    />
                    {errorName === "usernamedata" && !addEmloyee?.Name && (
                      <span className="contact_error-Addemployee">First Name is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Last Name"
                      value={addEmloyee?.LastName}
                      onChange={(e) => setAddEmloyee({ ...addEmloyee, LastName: e?.target?.value })}
                      onBlur={(e) => setErrorLastName(!e?.target?.value ? "userLastnamedata" : "false")}
                    />
                    {errorLastName === "userLastnamedata" && !addEmloyee?.LastName && (
                      <span className="contact_error-Addemployee">Last Name is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Email*"
                      value={addEmloyee?.Email}
                      readOnly={isUpdate}
                      disabled={isUpdate}
                      onChange={(e) => !isUpdate && setAddEmloyee({ ...addEmloyee, Email: e?.target?.value })}
                      onBlur={(e) => setErrorEmail(!e?.target?.value ? "userEmail" : "false")}
                    />
                    {errorEmail === "userEmail" && !addEmloyee?.Email && (
                      <span className="contact_error-Addemployee">Email is required.</span>
                    )}
                  </div>

                  {/* Password — ADD only, placed next to Email */}
                  {!isUpdate && (
                    <div className="Addemployee-inputs col-md-4">
                      <FloatingLabelInput
                        type="password"
                        label="Password*"
                        value={addEmloyee?.Password}
                        onChange={(e) => setAddEmloyee({ ...addEmloyee, Password: e?.target?.value })}
                        onBlur={(e) => setErrorPassword(!e?.target?.value ? "password" : "false")}
                      />
                      {errorPassword === "password" && !addEmloyee?.Password && (
                        <span className="contact_error-Addemployee">Password is required.</span>
                      )}
                    </div>
                  )}

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Address"
                      value={addEmloyee?.Address}
                      onChange={(e) => setAddEmloyee({ ...addEmloyee, Address: e?.target?.value })}
                      onBlur={(e) => setErrorAddress(!e?.target?.value ? "userAddress" : "false")}
                    />
                    {errorAddress === "userAddress" && !addEmloyee?.Address && (
                      <span className="contact_error-Addemployee">Address is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      label="Education"
                      value={addEmloyee?.Education}
                      onChange={(e) => setAddEmloyee({ ...addEmloyee, Education: e?.target?.value })}
                    />
                  </div>

                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      type="tel"
                      label="Phone No"
                      maxLength="10"
                      value={addEmloyee?.Phone}
                      onChange={(e) => {
                        const inputMobile = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setAddEmloyee({ ...addEmloyee, Phone: inputMobile });
                      }}
                      onBlur={(e) => setErrorPhone(!e?.target?.value ? "userPhone" : "false")}
                    />
                    {errorPhone === "userPhone" && !addEmloyee?.Phone && (
                      <span className="contact_error-Addemployee">Phone Number is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      type="tel"
                      maxLength="10"
                      label="Emergency Contact No."
                      value={addEmloyee?.EmergencyContact}
                      onChange={(e) => {
                        const inputMobile = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setAddEmloyee({ ...addEmloyee, EmergencyContact: inputMobile });
                      }}
                      onBlur={(e) => setErrorEmergencyContact(!e?.target?.value ? "userEmergencyContact" : "false")}
                    />
                    {errorEmergencyContact === "userEmergencyContact" && !addEmloyee?.EmergencyContact && (
                      <span className="contact_error-Addemployee">Emergency Contact Number is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs-gender col-md-6">
                    <label className="label-manaegement-section">Gender</label>
                    <Select
                      classNamePrefix="genderSelect"
                      placeholder="Please Select Gender"
                      options={Gender}
                      value={addEmloyee?.Gender}
                      onChange={(selectedOption) => setAddEmloyee({ ...addEmloyee, Gender: selectedOption })}
                    />
                    {errorGender === "userGender" && !addEmloyee?.Gender && (
                      <span className="contact_error-Addemployee">Gender is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs-gender col-md-6">
                    <label className="label-manaegement-section">Marital Status</label>
                    <Select
                      classNamePrefix="maritalStatusSelect"
                      placeholder="Please Select Marital Status"
                      options={MaritalStatusOptions}
                      value={addEmloyee?.MaritalStatus || ""}
                      onChange={(selectedOption) => setAddEmloyee({ ...addEmloyee, MaritalStatus: selectedOption || null })}
                    />
                  </div>

                  {/* ── SECTION: Dates ── */}
                  <div className="addemployee-section-title col-12">Dates</div>

                  <div className="Addemployee-inputs-cal col-md-4">
                    <label htmlFor="DateOfBirth">Date of Birth{isUpdate ? "*" : ""}</label>
                    <input
                      type="date"
                      id="DateOfBirth"
                      value={addEmloyee?.DateOfBirth}
                      onChange={DateOfBirth}
                      max={moment().subtract(18, "years").format("YYYY-MM-DD")}
                    />
                    {errorDateOfBirth === "userDateOfBirth" && !addEmloyee?.DateOfBirth && (
                      <span className="contact_error-dob">Date Of Birth is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs-cal col-md-4">
                    <label>Date of Joining{isUpdate ? "*" : ""}</label>
                    <input
                      type="date"
                      value={addEmloyee?.DateOfJoining}
                      onChange={(e) => setAddEmloyee({ ...addEmloyee, DateOfJoining: e?.target?.value })}
                      max={currentDate}
                    />
                    {errorDateOfJoining === "userDateOfJoining" && !addEmloyee?.DateOfJoining && (
                      <span className="contact_error-dob">Date Of Joining is required.</span>
                    )}
                  </div>

                  <div className="Addemployee-inputs-cal col-md-4">
                    <label>Date of Leaving</label>
                    <input
                      type="date"
                      value={addEmloyee?.DateOfLeaving}
                      onChange={(e) => setAddEmloyee({ ...addEmloyee, DateOfLeaving: e?.target?.value })}
                      max={currentDate}
                    />
                  </div>

                  {/* ── SECTION: Role & Department ── */}
                  <div className="addemployee-section-title col-12">Role & Department</div>

                  <div className="Addemployee-inputs-gender col-md-4">
                    <label className="label-manaegement-section">User Role{!isUpdate ? "*" : ""}</label>
                    <Select
                      classNamePrefix="prefix-department"
                      placeholder="Please Select User Role"
                      options={userRoleData}
                      getOptionLabel={(options) => options?.RoleName}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserRole}
                      value={addEmloyee?.UserRole}
                    />
                    {userRoleError === "userRole" && !finalUserRole && (
                      <span className="contact_error-Addemployee">User Role is required.</span>
                    )}
                  </div>

                  {addEmloyee?.UserRole?.RoleName !== "Admin" && addEmloyee?.UserRole?.Id ? (
                    <div className="Addemployee-inputs-department col-md-4">
                      <label className="label-manaegement-section">Department</label>
                      <Select
                        classNamePrefix="prefix-department"
                        placeholder="Please Select Department"
                        options={departmentData}
                        getOptionLabel={(options) => options?.label}
                        getOptionValue={(options) => options?.value}
                        value={
                          addEmloyee?.UserRole?.RoleName === "HR"
                            ? departmentData?.find((d) => d.label === "Management")
                            : {
                                value: addEmloyee?.Department?.Id ? addEmloyee?.Department?.Id : addEmloyee?.Department?.value,
                                label: addEmloyee?.Department?.Name ? addEmloyee?.Department?.Name : addEmloyee?.Department?.label,
                              }
                        }
                        onChange={handleDepartmentChange}
                      />
                      {departmentError === "department" && !departmentId && (
                        <span className="validation-error-addemployee">* Please Select department.</span>
                      )}
                    </div>
                  ) : null}

                  {addEmloyee.UserRole?.RoleName !== "Admin" &&
                    addEmloyee?.Department &&
                    addEmloyee?.Department.Name !== "Sales/Marketing" &&
                    addEmloyee?.Department.label !== "Sales/Marketing" ? (
                    <div className="Addemployee-inputs-department-optional col-md-4">
                      <label className="label-manaegement-section">Designation</label>
                      <Select
                        classNamePrefix="subdepartment-dropdown"
                        placeholder="Please Select Designation"
                        options={DesignationData}
                        getOptionLabel={(options) => options?.DesignationName}
                        getOptionValue={(options) => options?.Id}
                        onChange={handleDesignationData}
                        value={addEmloyee?.Designation}
                      />
                      {designationDepartmentError === "userDepartmentDesignation" && !designationId && (
                        <span className="contact_error-Addemployee">* Please Select Designation.</span>
                      )}
                    </div>
                  ) : null}

                  {(addEmloyee?.Designation &&
                    addEmloyee?.UserRole?.RoleName !== "TeamLead" &&
                    addEmloyee?.UserRole?.RoleName !== "HR") ||
                  addEmloyee.Department?.Name === "Sales/Marketing" ||
                  addEmloyee.Department?.label === "Sales/Marketing" ? (
                    <div className="Addemployee-inputs-department-optional col-md-4">
                      <label className="label-manaegement-section">Team Lead</label>
                      <Select
                        classNamePrefix="subdepartment-dropdown"
                        placeholder="Please Select Team Lead"
                        options={teamLeadData}
                        getOptionLabel={(options) => options?.FirstName}
                        getOptionValue={(options) => options?.Id}
                        onChange={handleTeamLeadData}
                        value={addEmloyee?.TeamLead}
                      />
                      {teamLeadDepartMentError === "userDepartmentTeamLead" && !addEmloyee?.TeamLead && (
                        <span className="contact_error-Addemployee">* Please Select Team Lead.</span>
                      )}
                    </div>
                  ) : null}

                  {/* ── SECTION: Documents — ADD only ── */}
                  {!isUpdate && (
                    <>
                      <div className="addemployee-section-title col-12">Documents</div>

                      <div className="addemployee-file-group col-md-6">
                        <label className="upload-image-add-employee">Profile Image</label>
                        <div className="Addemployee-input-file">
                          <input
                            className="Addemployee-file-input"
                            id="fileInput"
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                          />
                        </div>
                        {uploadImageError === "useruploadImage" && !addEmloyee?.UploardImage && (
                          <span className="contact_error-dob">Image is required</span>
                        )}
                      </div>

                      <div className="addemployee-file-group col-md-6">
                        <label className="upload-image-add-employee">Aadhaar Files (Multiple)*</label>
                        <div className="Addemployee-input-file">
                          <input
                            className="Addemployee-file-input"
                            id="adhaarInput"
                            type="file"
                            ref={adhaarFileInputRef}
                            onChange={(e) => handleFileChange(e, "adhaar")}
                            multiple
                            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                          />
                        </div>
                        {(!adhaarImageFiles || adhaarImageFiles.length === 0) ? (
                          <span className="contact_error-dob">Aadhaar files are required</span>
                        ) : (
                          <span className="contact_success-doc">✓ {adhaarImageFiles.length} file(s) selected</span>
                        )}
                      </div>
                    </>
                  )}

                  {/* Profile image upload for UPDATE (no aadhaar) */}
                  {isUpdate && (
                    <>
                      <div className="addemployee-section-title col-12">Documents</div>
                      <div className="addemployee-file-group col-md-6">
                        <label className="upload-image-add-employee">Profile Image</label>
                        <div className="Addemployee-input-file">
                          <input
                            className="Addemployee-file-input"
                            id="fileInput"
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Action Buttons */}
                  <div className="Addemployee-buttons col-12">
                    <button className="Addemployee-submit-button" onClick={() => handleAddEmployee()}>
                      {isUpdate ? "Update" : "Submit"}
                    </button>
                    <button onClick={handleEmptyInputData} className="Addemployee-Cancel-button">
                      Cancel
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddEmployee;